import { useState, useEffect, useMemo } from 'react';
export function useForm(generator) {
    const schema = useMemo(() => generator(), []);
    const [form] = useState(schema);
    useEffect(() => {
        form.setName('');
    }, []);
    return form;
}
